const PreviousAppointments = ({ appointments, formatDate, invoiceMap, onGenerateInvoice, onViewInvoice }) => {
    if (!appointments?.length) {
        return null;
    }

    return (
        <div className="d-flex flex-column my-3 mb-4">
            <h5 className="fw-semibold mb-2">Previous Appointments</h5>
            {appointments.map((appointment) => (
                <div
                    className="d-flex flex-column shadow-sm p-3 mb-3"
                    style={{ backgroundColor: '#f8f9fa', borderRadius: '12px' }}
                    key={appointment.BookingConsultationId || appointment.AppointmentDate}
                >
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <span className="fw-bold">{appointment.Name}</span>
                        <span>{formatDate(appointment.AppointmentDate)}</span>
                    </div>
                    <div className="d-flex justify-content-start gap-3 mt-3">
                        <button type="button" onClick={() => onViewInvoice(appointment)} className="btn btn-outline-primary btn-sm">
                            <i className="bi bi-eye me-1"></i>View
                        </button>
                        {!invoiceMap[appointment.BookingConsultationId] && (
                            <button type="button" onClick={() => onGenerateInvoice(appointment)} className="btn btn-outline-success btn-sm">
                                <i className="bi bi-file-earmark-earphones me-1"></i>Generate
                            </button>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default PreviousAppointments;
